import {CallMeNowDealerError} from './CallMeNowDealerError.js'
import {ContactDealerError} from './ContactDealerError.js'
import ContractError from './ContractError.js'
import DealerError from './DealerError.js'
import {DealerServiceDealerError} from './DealerServiceDealerError.js'
import {GetDealerError} from './GetDealerError.js'
import {GetPaginationSearchUrlDealerError} from './GetPaginationSearchUrlDealerError.js'
import {SearchResultsDealerError} from './SearchResultsDealerError.js'
import {TrackingPhoneError} from './TrackingPhoneError.js'

export default class DealerErrorsFactory {
  static contractError = msg => new ContractError(msg)

  static dealerError = msg => new DealerError(msg)

  static dealerServiceDealerError = msg => new DealerServiceDealerError(msg)

  static contactDealerError = msg => new ContactDealerError(msg)

  static trackingPhoneError = msg => new TrackingPhoneError(msg)

  static getDealerError = msg => new GetDealerError(msg)

  static searchResultsDealerError = msg => new SearchResultsDealerError(msg)

  static callMeNowDealerError = msg => new CallMeNowDealerError(msg)

  static getPaginationSearchUrlDealerError = msg => new GetPaginationSearchUrlDealerError(msg)
}
